if (!customElements.get('product-wrapper')) {
  class ProductWrapper extends HTMLElement {
    constructor() {
      super();
      this.select = document.querySelector('.product__variant-select select');
      this.productWrapper = this.querySelector('.product');
      this.productUrl = this.dataset.handle;
      this.trustpilotContainer = null;
    }
    
    connectedCallback() {
      this.init();
    }
    
    init() {
      // updates the section according to the variant
      document.addEventListener('productChange', this.productChangeHandler.bind(this));
      
      document.addEventListener('scroll', () => {
        this.checkIfFooterVisible();
      }, {passive: true});
    }
    
    disconnectedCallback() {
      document.removeEventListener('productChange', this.productChangeHandler.bind(this));
    }
    
    productChangeHandler(e) {
      // SCHRITT 1: Trustpilot Widget physisch aus dem DOM entfernen (nicht klonen!)
      const tpWrap = this.querySelector('.tp-stars-wrap');
      if (tpWrap && tpWrap.parentNode) {
        // Merke dir die Position im DOM
        this.tpParent = tpWrap.parentNode;
        this.tpNextSibling = tpWrap.nextSibling;
        
        // Entferne das Widget temporär aus dem DOM (speichere Referenz)
        this.trustpilotContainer = this.tpParent.removeChild(tpWrap);
        console.log('💾 Trustpilot widget removed from DOM');
      }
      
      fetch(`${window.Shopify.routes.root}products/${this.productUrl}?variant=${e.detail}&section_id=${this.dataset.section}`)
      .then(res => res.text())
      .then(res => {
        let html = new DOMParser()
        .parseFromString(res, 'text/html')
        .querySelector('.shopify-section .product product-wrapper');

        document.querySelector('.product__media--nutrition-modal')?.remove();
        this.innerHTML = html.innerHTML;
        
        // SCHRITT 2: Trustpilot Widget an die richtige Stelle wieder einfügen
        if (this.trustpilotContainer) {
          // Finde die neue pdp-title-wrap
          const newTitleWrap = this.querySelector('.pdp-title-wrap');
          if (newTitleWrap) {
            // Entferne das neue (leere) tp-stars-wrap
            const newTpWrap = newTitleWrap.querySelector('.tp-stars-wrap');
            if (newTpWrap) {
              newTpWrap.remove();
            }
            
            // Füge das originale Widget wieder ein
            newTitleWrap.appendChild(this.trustpilotContainer);
            console.log('✅ Trustpilot widget restored with working iframes');
          }
        }
      });
    }
    
    checkIfFooterVisible() {
      const footer = document.getElementById('shopify-section-footer');
      const stickyAddToCart = document.querySelector('.product__sticky-add-to-cart');
        
      if (!footer || !stickyAddToCart) return;
      
      if (footer.getBoundingClientRect().left >= -footer.offsetHeight
        && footer.getBoundingClientRect().bottom <= (window.innerHeight || document.documentElement.clientHeight) + footer.offsetHeight) {
        stickyAddToCart.classList.add('hide');
      } else {
        stickyAddToCart.classList.remove('hide');
      }
    }
  }

  customElements.define('product-wrapper', ProductWrapper);
}